import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Headroom from "react-headroom";
import CheeseburgerMenu from "cheeseburger-menu";
import classNames from "classnames";

export default function nav() {
  const element = document.getElementById("headroom");
  const navLinks = JSON.parse(element.dataset.navLinks || "[]");
  const homeBanner = (element.dataset.homeBanner || "").trim();

  ReactDOM.render(
    <Nav
      headerLogo={element.dataset.headerLogo}
      fadeIn={element.dataset.fadeIn}
      homeBanner={homeBanner}
      generalEnquiresEmail={element.dataset.generalEnquiresEmail}
      generalEnquiresTelephone={element.dataset.generalEnquiresTelephone}
      navLinks={navLinks}
      sponsorImage={element.dataset.sponsorImage}
      sponsorLink={element.dataset.sponsorLink}
    />,
    element
  );
}

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  if (!ref) {
    return false;
  }

  const observer = new IntersectionObserver(([entry]) =>
    setIntersecting(entry.isIntersecting)
  );

  useEffect(() => {
    observer.observe(ref);
    return () => {
      observer.disconnect();
    };
  }, []);

  return isIntersecting;
}

function Nav({
  headerLogo,
  fadeIn,
  homeBanner,
  generalEnquiresEmail,
  generalEnquiresTelephone,
  navLinks,
  sponsorImage,
  sponsorLink,
}) {
  const [backgroundColor, setBackgroundColor] = useState("offWhite2");
  const [menu, setMenu] = useState(false);
  const headerInView = useOnScreen(
    document.querySelector(".image-header, .video-header, .gallery__slideshow")
  );

  function openMenu() {
    setMenu(true);
  }

  function closeMenu() {
    setMenu(false);
  }

  return (
    <>
      <Menu
        isOpen={menu}
        closeMenu={closeMenu}
        closeCallback={closeMenu}
        generalEnquiresEmail={generalEnquiresEmail}
        generalEnquiresTelephone={generalEnquiresTelephone}
        navLinks={navLinks}
        sponsorImage={sponsorImage}
        sponsorLink={sponsorLink}
      />
      <Headroom
        onPin={() => setBackgroundColor("white")}
        onUnfix={() => setBackgroundColor("offWhite2")}
      >
        <div className="nav__stack">
          {homeBanner ? (
            <div className="nav__banner" role="status">
              {homeBanner}
            </div>
          ) : null}
          <div
            className={classNames("nav", {
              "nav--transparent": headerInView,
              "nav--fade-in": fadeIn,
            })}
            style={{
              "--navBackground": `var(--${
                headerInView ? "transparent" : backgroundColor
              })`,
            }}
          >
            <div className="nav__button" onClick={openMenu}>
              <div
                className={classNames("nav__line", {
                  "nav__line--white": headerInView,
                })}
              ></div>
              <div
                className={classNames("nav__line", {
                  "nav__line--white": headerInView,
                })}
              ></div>
              <div
                className={classNames("nav__line", {
                  "nav__line--white": headerInView,
                })}
              ></div>
            </div>
            {headerLogo || !headerInView ? (
              <a
                className={classNames("nav__logo", {
                  "nav__logo--white": headerInView,
                })}
                href="/"
              ></a>
            ) : null}
          </div>
        </div>
      </Headroom>
    </>
  );
}

function Menu({
  isOpen,
  closeMenu,
  closeCallback,
  generalEnquiresEmail,
  generalEnquiresTelephone,
  navLinks,
  sponsorImage,
  sponsorLink,
}) {
  return (
    <CheeseburgerMenu
      isOpen={isOpen}
      noShadow={true}
      closeCallback={closeCallback}
    >
      <div className="menu">
        <nav className="menu__nav">
          <div className="menu__button" onClick={closeMenu}>
            <div className="menu__line"></div>
            <div className="menu__line"></div>
          </div>
          <ul className="menu__nav-list">
            {navLinks.map((item) => (
              <li key={item.id} className="menu__nav-item">
                <a
                  className="menu__nav-link"
                  href={item.url}
                  target={item.target ? item.target : "_self"}
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
          <div className="caption-title menu__get-in-touch">
            <h4 className="menu__get-in-touch-title">Get in touch</h4>
            {generalEnquiresEmail || generalEnquiresTelephone ? (
              <ul className="menu__get-in-touch-list">
                {generalEnquiresEmail ? (
                  <li className="menu__get-in-touch-item">
                    <a
                      className="menu__get-in-touch-link"
                      href={`mailto:${generalEnquiresEmail}`}
                    >
                      {generalEnquiresEmail}
                    </a>
                  </li>
                ) : null}

                {generalEnquiresTelephone ? (
                  <li className="menu__get-in-touch-item">
                    <a
                      className="menu__get-in-touch-link"
                      href={`tel:${generalEnquiresTelephone}`}
                    >
                      {generalEnquiresTelephone}
                    </a>
                  </li>
                ) : null}
              </ul>
            ) : null}
            {sponsorImage && (
              <div className="menu__sponsor">
                <h4 className="menu__get-in-touch-title">In support of</h4>
                {sponsorLink ? (
                  <a
                    href={sponsorLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="menu__sponsor-image"
                      src={sponsorImage}
                      alt="Sponsor"
                    />
                  </a>
                ) : (
                  <img
                    className="menu__sponsor-image"
                    src={sponsorImage}
                    alt="Sponsor"
                  />
                )}
              </div>
            )}
          </div>
        </nav>
      </div>
    </CheeseburgerMenu>
  );
}
